import _assign from 'lodash/assign';

import ActionTypes from '../constants/ActionTypes';
import initialState from '../store/initialState';

export default (state = initialState.onboarding, action) => {
  switch (action.type) {
    case `${ActionTypes.CUSTOM_FORM_UPLOAD_FILE}_SUCCESS`: {
      const temp = _assign({}, state.uploadedFiles, {
        [action.id]: action.payload,
      });
      return _assign({}, state, { uploadedFiles: temp });
    }
    default:
      return state;
  }
};
